/** Valantis stHYPE / wstHYPE — burn-request enumeration on the
 *  Overseer (`0xb96f07367e69e86d6e9c3f29215885104813eeae`, HyperEVM
 *  999, VERIFIED via Sourcify).
 *
 *  The **paginated** `getBurns(user, start, count)` is used (the no-arg
 *  `getBurns(user)` / `getBurnIds(user)` overloads REVERT for users
 *  with zero burns — the common case). It returns the user's `Burn[]`
 *  (amount/user/completed/sum), the parallel burn `ids`, and a parallel
 *  `redeemable` bool array. `completed` burns have already been
 *  redeemed. */
export const ValantisBurnAbi = [
  {
    name: 'getBurns',
    type: 'function',
    stateMutability: 'view',
    inputs: [
      { type: 'address', name: 'user' },
      { type: 'uint256', name: 'start' },
      { type: 'uint256', name: 'count' },
    ],
    outputs: [
      {
        type: 'tuple[]',
        components: [
          { name: 'amount', type: 'uint88' },
          { name: 'user', type: 'address' },
          { name: 'completed', type: 'bool' },
          { name: 'sum', type: 'uint256' },
        ],
      },
      { type: 'uint256[]' },
      { type: 'bool[]' },
    ],
  },
] as const
